import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { security_key, Url } from "../../Services/Api";
import "./ECommerce.css";
import "../Page.css";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { CiWarning } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { IoImageOutline } from "react-icons/io5";
import { uploadImage } from "../../Services/functions";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";

const ProductFeaturesPg = () => {
    const modalRef = useRef(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [attrData, setAttrData] = useState({
        name: "",
        title: "",
        image: ""
    });
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [editId, setEditId] = useState(null);
    const [showParentForm, setShowParentForm] = useState(true);
    const [showAttributeForm, setShowAttributeForm] = useState(false);
    const [selectedAttribute, setSelectedAttribute] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [formData, setFormData] = useState({
        attributeId: "",
        label: "",
        value: "",
        description: "",
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [error, setError] = useState(null);

    const [modalView, setModalView] = useState(false);
    const [modaldata, setModalData] = useState([]);
    const [isUploaded, setIsUploaded] = useState(false);
    const [imageSendPayload, setImageSendPayload] = useState({
        file: null,
        alt_text: "",
        title: "",
        description: "",
        link_url: "",
    });

    const handleGalleryModalOpen = () => {
        setModalView(true);
    };

    const handleGalleryModalClose = () => {
        setModalView(false);
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const api = `${Url}/api/v1/media/product-features/add`;

        if (file) {
            setImageSendPayload((prevData) => ({
                ...prevData,
                file: file,
            }));
            alert("wait");
            const imagePayloadToSend = new FormData();
            imagePayloadToSend.append("image", file);
            imagePayloadToSend.append("alt_text", imageSendPayload.alt_text);
            imagePayloadToSend.append("title", imageSendPayload.title);
            imagePayloadToSend.append("description", imageSendPayload.description);
            imagePayloadToSend.append("image_url", imageSendPayload.image_url);
            imagePayloadToSend.append("link_url", imageSendPayload.link_url);
            await uploadImage(imagePayloadToSend, api, setUploadedStates);
            await getApi()
        }
        setIsUploaded(true);
    };

    const handleImageSelect = (image) => {
        setAttrData((prevData) => ({
            ...prevData,
            image: image.image_url,
        }));
        handleGalleryModalClose()
    }
    const [uploadedStatus, setUploadedStates] = useState(null);
    const rowsPerPage = 10;

    const fetchTableData = async () => {
        setLoading(true);
        setError(null);
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        setTimeout(async () => {
            try {
                const response = await axios.get(`${Url}/api/v1/product-features/get`);
                const productAttributes = response.data.data || [];
                setData(productAttributes);
                setToastMessage("Collections Data have been fetched successfully!");
                setShowMessage(true);
            } catch (error) {
                const errMsg = error?.response?.data?.message || error.message;
                setError(errMsg);
                setToastMessage(`Failed to fetch Product Attribute Data: ${errMsg}`);
                setShowMessage(true);
            } finally {
                setLoading(false);
            }
        }, 2000);
    };

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);
            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    useEffect(() => {
        if (selectedAttribute) {
            setFormData({
                label: "",
                value: "",
                description: "",
                attributeId: selectedAttribute._id,
            });
        }
    }, [selectedAttribute]);

    useEffect(() => {
        fetchTableData();
    }, []);

    const handleSearch = (value) => {
        setSearchTerm(value);
    };

    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allRowIds = data.map((row) => row._id);
            setSelectedRows(allRowIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (rowId) => {
        setSelectedRows((prevSelected) => {
            if (prevSelected.includes(rowId)) {
                return prevSelected.filter((id) => id !== rowId);
            } else {
                return [...prevSelected, rowId];
            }
        });
    };

    const handleInputChange = (e, fieldType = null, fieldName = null) => {
        const { name, type, checked, value } = e.target;

        if (fieldType === "dropdown") {
            setAttrData((prevState) => ({
                ...prevState,
                [fieldName]: value,
            }));
        } else {
            let newSlug = attrData.slug;

            if (name === "name") {
                newSlug = value.toLowerCase().replace(/\s+/g, "-");
            }

            setAttrData({
                ...attrData,
                [name]: type === "checkbox" ? checked : value,
                slug: newSlug,
            });
        }
    };

    const handleDuplicate = () => {
        console.log("Duplicate selected rows:", selectedRows);
    };


    const toggleDropdown = (uid) => {
        setOpenDropdownId((prevId) => (prevId === uid ? null : uid));
    };

    const handleAction = (action, row) => {
        console.log(`Action: ${action} triggered for row:`, row);
        switch (action) {
            case "edit":
                setOpenDropdownId(null);
                setEditId(row._id);
                setAttrData({
                    name: row.name,
                    title: row.title,
                    image: row.image
                })
                break;
            case "delete":
                confirmDelete(row);
                setOpenDropdownId(null);
                break;
            default:
                break;
        }
    };

    const confirmDelete = (row) => {
        setCurrentRowId(row._id);
        setShowConfirm(true);
    };

    const cancelDelete = () => {
        setShowConfirm(false);
    };

    const handleClickOutside = (event) => {
        if (
            !event.target.closest(".dropdown-menu") &&
            !event.target.closest(".bar-icon")
        ) {
            setOpenDropdownId(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleAddAttribute = async () => {
        const payload = {
            name: attrData.name,
            title: attrData.title,
            image: attrData.image
        };

        try {
            let successMessage = "Product Feature submitted successfully!";
            setLoading(true);
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };

            const response = await axios.post(
                `${Url}/api/v1/product-features/add`,
                payload,
                {
                    headers: headers,
                }
            );

            setToastMessage(successMessage);
            setShowMessage(true);

            setAttrData({
                name: "",
                title: "",
                image: ""
            });

            fetchTableData();
        } catch (error) {
            let errorMessage = "An error occurred. Please try again.";
            console.error("Error submitting form:", error);
            setToastMessage(errorMessage);
            setShowMessage(true);
        } finally {
            setLoading(false);
        }
    };


    const handleUpdateAttribute = async () => {
        const payload = {
            name: attrData.name,
            title: attrData.title,
            image: attrData.image
        };

        try {
            setLoading(true);
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };
            const response = await axios.put(
                `${Url}/api/v1/product-features/${editId}`, // editId should be the uid
                payload,
                {
                    headers: headers
                }
            );

            setToastMessage("Product Feature updated successfully!");
            setShowMessage(true);

            // Reset the form
            setAttrData({
                name: "",
                title: "",
                image: ""
            });
            setEditId(null);

            // Refresh the table
            fetchTableData();
        } catch (error) {
            console.error("Error updating Feature:", error);
            setToastMessage("An error occurred. Please try again.");
            setShowMessage(true);
        } finally {
            setLoading(false);
        }
    };

    const handleCancelEdit = () => {
        setAttrData({
            name: "",
            title: "",
            image: ""
        });
        setEditId(null);
    }


    const customStyles = {
        headCells: {
            style: {
                height: "clamp(50px, 5vw, 56px)",
                background: "transparent",
                opacity: "1",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
                overflow: "wrap",
                textOverflow: "ellipsis",
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
        cells: {
            style: {
                height: "clamp(50px, 6vw, 66px)",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflow: "wrap",
                textOverflow: "ellipsis",
                overflow: "visible",
                position: "relative",
            },
        },
    };

    const handleDelete = () => {
        console.log(`Deleting item with ID: ${currentRowId}`);
        if (currentRowId) {
            deleteItem(currentRowId);
        }
    };

    const deleteItem = async (id) => {
        setIsLoading(true);
        setIsActive(true);

        try {
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };
            let failureMessage = "Product feature deleted successfully!";
            console.log(`Attempting to delete item with ID: ${id}`);

            const response = await fetch(`${Url}/api/v1/product-features/${id}`, {
                method: "DELETE",
                headers
                
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const responseData = await response.json();

            console.log(`Delete response: `, responseData);
            console.log(`Selection with ID ${id} deleted successfully.`);

            setData((prevItems) => prevItems.filter((item) => item._id !== id));

            setToastMessage(failureMessage);
            setShowMessage(true);

            fetchTableData();
        } catch (error) {
            let errorMessage = "Failed to delete the selection. Please try again.";
            console.error("Error deleting item:", error);
            setToastMessage(errorMessage);
            setShowMessage(true);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
                setIsActive(false);
            }, 5000);
            setShowConfirm(false);
        }
    };

    const columns = [
        {
            name: (
                <input
                    type="checkbox"
                    style={{ margin: 0 }}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    checked={selectedRows.length === data.length && data.length > 0}
                />
            ),
            cell: (row) => loading ? (
                <ShimmerLoader width="20px" height="20px" />
            ) : (
                <input
                    type="checkbox"
                    style={{ margin: 0 }}
                    onChange={() => handleRowSelect(row._id)}
                    checked={selectedRows.includes(row._id)}
                />
            ),
            ignoreRowClick: true,
            width: "50px",
        },
        {
            name: "Image",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="125px" height="22.5px" borderRadius="20px" />
                ) : (
                    <img width="auto" height="50px" src={Url + row.image} />
                ),
            minWidth: "200px",
            maxWidth: "230px",
        },
        {
            name: "Name",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="125px" height="22.5px" borderRadius="20px" />
                ) : (
                    row.name
                ),
            minWidth: "200px",
            maxWidth: "230px",
        },
        {
            name: "Title",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="125px" height="22.5px" borderRadius="20px" />
                ) : (
                    row.title
                ),
            minWidth: "220px",
            maxWidth: "375px",
        },
        {
            name: "Action",
            cell: (row) => loading ? (
                <ShimmerLoader width="60px" height="22.5px" />
            ) : (
                <div style={{ position: "relative" }}>
                    <img
                        src={actionIcon}
                        alt="Action Icon"
                        width="40"
                        height="40"
                        style={{ cursor: "pointer", margin: 0, padding: 0 }}
                        className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
                            }`}
                        onClick={() => toggleDropdown(row._id)}
                    />
                    {openDropdownId === row._id && (
                        <div className={`dropdown-menu show animate-dropdown-left`}>
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                <li
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "5px 10px",
                                        border: "none",
                                    }}
                                    onClick={() => handleAction("edit", row)}
                                >
                                    <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                                    Quick Edit
                                </li>
                                <li
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        padding: "5px 10px",
                                        border: "none",
                                    }}
                                    onClick={() => handleAction("delete", row)}
                                >
                                    <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                                    Delete
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            ),
            minWidth: "80px",
            maxWidth: "120px",
        },
    ];



    const filteredData = data.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const placeholderRows = Array(7).fill({ title: "", name: "", image: "" });

    const displayedData = loading ? placeholderRows : paginatedData;



    const getApi = async () => {
        try {
            const response = await axios.get(`${Url}/api/v1/media/product-features/get`);
            setModalData(response.data.media);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getApi();
    }, []);

    return (
        <div className="ProductAttrPage">
            <div className="AttrSection-01">
                <span className="Section1-Leftside">Features</span>
                <div className="Section1-Rightside-Updated">
                    <div className="SearchBar-Alignment">
                        <SearchBar
                            onSearch={handleSearch}
                            icon={searchIcon}
                            placeholder="Search Featured"
                        />
                    </div>
                    {selectedRows.length > 0 && (
                        <div className="SelectionBtn-Row">
                            <>
                                <CustomBtn
                                    label="Duplicate"
                                    className="SelectedDuplicateBtn"
                                    onClick={handleDuplicate}
                                    type="button"
                                />
                                <CustomBtn
                                    label="Delete"
                                    className="SelectedDeleteBtn"
                                    type="button"
                                />
                            </>
                        </div>
                    )}
                </div>
            </div>

            <div
                className={`AttrSection-02 ${selectedRows.length > 0 ? "translate-down" : ""
                    }`}
            >
                <div className="Section2-Leftside">
                    <div className="Header">
                        {showParentForm
                            ? "Add New Feature"
                            : selectedAttribute?.type || ""}
                    </div>
                    <div className="NewAttr-Add">
                        {showParentForm && (
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleAddAttribute();
                                }}
                            >
                                <div className="form-row">
                                    <label htmlFor="name">
                                        Feature Name<span className="superscript">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        value={attrData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-row">
                                    <label htmlFor="title">
                                        Feature Title<span className="superscript">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        placeholder="title"
                                        value={attrData.title}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>


                                <div className="form-row">
                                    <label htmlFor="image">
                                        Feature Image<span className="superscript">*</span>
                                    </label>
                                    <div className="banner-upload">
                                        {attrData.image ? (
                                            <div className="image-preview-wrapper">
                                                <img
                                                    src={
                                                        //   isEditing
                                                        //     ? `${Url + attrData.image}`
                                                        //     :
                                                        `${Url + attrData.image}`
                                                    }
                                                    alt="Thumbnail"
                                                    className="image-preview"
                                                />
                                                <button
                                                    onClick={() => {
                                                        setAttrData((prevData) => ({
                                                            ...prevData,
                                                            image: "",
                                                        }));
                                                    }}
                                                    className="cancel-button"
                                                >
                                                    X
                                                </button>
                                            </div>
                                        ) : (
                                            <label
                                                htmlFor="image"
                                                className="upload-label"
                                                onClick={() => { handleGalleryModalOpen(true) }}
                                            >
                                                <div className="Catupload-button">
                                                    <IoImageOutline
                                                        size={45}
                                                        color="#555"
                                                        className="uploaded-image"
                                                    />
                                                </div>
                                                <span className="upload-text">Click to Upload Image</span>
                                            </label>
                                        )}
                                    </div>
                                </div>


                                <div className="SubmitBtn">
                                    {editId !== null && (
                                        <CustomBtn
                                            label="Cancel Edit"
                                            className="CancelEditBtn"
                                            onClick={handleCancelEdit}
                                            type="button"
                                        />
                                    )}
                                    <CustomBtn
                                        label={(editId === null || editId === 0) ? "Add Feature" : "Update"}
                                        className="AddCatBtn"
                                        onClick={(editId === null || editId === 0) ? handleAddAttribute : handleUpdateAttribute}
                                        type="button"
                                    />
                                </div>
                            </form>
                        )}
                    </div>
                </div>
                <div className="Section2-Rightside">
                    <div className="Attribute-Data">
                        <div>
                            <DataTable
                                columns={columns}
                                data={displayedData}
                                customStyles={customStyles}
                            // data={paginatedData}
                            />
                            <Pagination
                                activePageIndex={currentPage}
                                totalPages={totalPages}
                                onPrevPage={handlePrevPage}
                                onNextPage={handleNextPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* --- (PopUp) To Handle Confiramtion for Delete Operation of Single Category --- */}
            {showConfirm && (
                <div className="confirmation-modal">
                    <div className="Cat-modal-content" ref={modalRef}>
                        <CiWarning className="warning-icon" />
                        <div className="Delete-Heading">Warning</div>
                        <div className="Delete-Content">
                            Are you sure you want to delete this Attribute? <br />
                            This action cannot be undone.
                        </div>
                        <div className="separator-line"></div>
                        <div className="modal-actions">
                            <button
                                className="Cat-Delete-btn btn-secondary"
                                onClick={cancelDelete}
                            >
                                Cancel
                            </button>

                            <div className="SubmitBtn">
                                <CustomBtn
                                    label={
                                        isLoading ? (
                                            <div className="btn-loader-Category"></div>
                                        ) : (
                                            "Confirm"
                                        )
                                    }
                                    className={`Cat-Delete-btn btn-danger ${isActive ? "active" : ""
                                        }`}
                                    disabled={isLoading}
                                    onClick={handleDelete}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />
            <ImageGalleryPopup
                showImageGalleryPopUp={modalView}
                handleModalView={handleGalleryModalClose}
                handleFileChange={handleFileChange}
                onImageSelect={handleImageSelect}
                imageSendPayload={imageSendPayload}
                setImageSendPayload={setImageSendPayload}
                alt_text={imageSendPayload.alt_text}
                title={imageSendPayload.title}
                data={modaldata}
                getData={getApi}
            />
        </div>
    );
};

export default ProductFeaturesPg;